export default __webpack_public_path__ + "static/media/eye.802109e9.svg";